import React, {Component} from 'react';
import './App.css';
import $ from 'jquery';
// or less ideally

import {withTranslation, Trans} from "react-i18next";
import {Link} from "react-router-dom";

import {Helmet} from "react-helmet";
import Slider from "react-slick";
import mainSlideImg from "./img/mainSlider.jpg";


class Services extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loaded : false,
            services : [],
            expertise : []
        }
    }


    componentDidMount() {
        $(window).scrollTop(0);


    }


    render() {
        const {i18n, t} = this.props;

        return (
            <div>
                <Helmet>
                    <title>{i18n.exists('services.seo.title') ? t('services.seo.title') : "Agile CE"}</title>
                    <meta name="description" content={i18n.exists('services.seo.description') ? t('services.seo.description') : ""} />
                    <meta property="og:title" content={i18n.exists('services.seo.title') ? t('services.seo.title') : "Agile CE"} />
                    <meta property="og:description" content={i18n.exists('services.seo.description') ? t('services.seo.description') : ""} />
                </Helmet>

                <div className="container content fade-in-website services" id="services">

                    <h3>Statika a dynamika staveb</h3>

                    <span>Věnujeme stejnou pozornost jak projektům velkého rozsahu, tak projektům menším – rádi pracujeme i na návrzích dílčích architektonických prvků, jako jsou schodiště, umělecké instalace a designové detaily. Naším hlavním cílem při práci s klienty a architekty je umožnit i ambiciózní a komplikované záměry pomocí přímočarých a inovativních konstrukčních řešení. Využíváme zkušeností nabytých při práci s prominentními architekty a klienty v ČR i v zahraničí.
                    Navrhujeme nosné konstrukce z oceli, betonu, dřeva, zdiva, ale pracujeme i se speciálními materiály jako je sklo, CLT panely, vysokopevnostní beton, nerezová ocel nebo hliník.
                    Zpracujeme pro Vás návrhy pro novostavby i rekonstrukce, nástavby a přístavby, vypracujeme také statické posudky a posudky dynamického chování.
                        Navrhujeme také konstrukce pro činnosti prováděné hornickým způsobem dle Vyhlášky 55/1996 Sb.</span>
<br/><br/>
                    <h3>Mostní a inženýrské konstrukce</h3>
                    <span> V rámci Agile Consulting Engineers navrhujeme objekty silniční a železniční infrastruktury, jak jsou mosty, tunely, opěrné zdi, propustky a podchody. Pracujeme i na projektech městské infrastruktury, jako jsou kolektory, objekty kanalizační sítě a podobně.
                    Navrhujeme také objekty v průmyslových areálech jako jsou haly, rampy, stožáry, potrubní mosty, konstrukce pro zásobníky a podpůrné konstrukce pro výrobní linky a třídiče v lomech.
                    </span>
                    <br/><br/>

                        <h3>Geotechnika a speciální zakládání</h3>
                        <span> Spolu s našimi externími konzultanty v rámci dceřiné firmy <a href="http://www.agile-ge.cz/" target="_blank">Agile Geotechnics s.r.o.</a> zpracováváme projekty základových konstrukcí i v komplikovaných geologických poměrech, včetně návrhu pilot a mikropilot, zajištění stavebních jam, zpevňování podloží a stabilizace svahů.
                    Nabízíme návrhy podchycení nebo zesílení stávajících základů, například v projektech nových podzemních prostorů pod stávajícími objekty.
                        </span>
                    <br/><br/>

                    <h3>Činnosti prováděné hornickým způsobem</h3>
                    <span> Agile Consulting Engineers je držitelem  <a href="./BU.pdf" target="_blank"><u>oprávnění</u></a> k projektování a navrhování objektů a zařízení, která jsou součástí činnosti prováděné hornickým způsobem.
                        </span>
                    <br/><br/>


                            <h3>Inženýrsko-geologické průzkumy, stavebně-technické průzkumy a pasportizace</h3>
                            <span> V rámci naší dceřiné firmy <a href="http://www.agile-ge.cz/" target="_blank">Agile Geotechnics s.r.o.</a> dále nabízíme kompletní služby v oblasti inženýrsko-geologických průzkumů, od přesného zadání přes koordinaci a provedení sond a zkoušek až po geologickou interpretaci a závěrečnou zprávu. Průzkumy jsou šité „na míru“ potřebám projektu a klienta tak, aby se podařilo minimalizovat investici do průzkumu samotného a zároveň optimalizovat návrh základových konstrukcí s důrazem na jejich cenovou efektivnost.
                    Stavebně technické průzkumy a pasportizace nabízíme i samostatně, ale zejména pak v rámci projektů rekonstrukcí, nástaveb a přístaveb, kde průzkum můžeme přesně přizpůsobit potřebám budoucího návrhu.
                            </span>
                    <br/><br/>

                    <h3> Autorský dozor</h3>
                                <span> Autorský dozor nabízíme a doporučujeme klientům na každém projektu.
                                </span>
                    <br/><br/>

                        <h3> Konzultace projektů a investičních záměrů, optimalizace návrhů</h3>
                                    <span> Rádi s Vámi zkonzultujeme investiční záměr nebo konceptuální návrh z hlediska konstrukčního řešení. Nabízíme také optimalizace návrhů nosných konstrukcí za účelem dosažení maximální cenové efektivity.
                                    </span>

                </div>

            </div>
        );
    }
}

export default withTranslation()(Services);
